import React from 'react';
import {Box, Button, Stack} from '@mui/material';
import { YesNoQuestion } from 'crqlar-react-common/dist/models/forms/form';
import EditableTypography from 'crqlar-react-common/dist/components/EditableTypography';
import MdEditor from 'crqlar-react-common/dist/components/MdEditor';
import {useTranslation} from 'react-i18next';

interface YesNoEditorProps {
    question: YesNoQuestion;
    onQuestionUpdate: (question: YesNoQuestion) => void;
}

const YesNoEditor: React.FC<YesNoEditorProps> = ({
                                                     question,
                                                     onQuestionUpdate
                                                 }) => {
    const {t} = useTranslation();

    // Handle title update
    const handleTitleUpdate = (title: string) => {
        onQuestionUpdate({
            ...question,
            title
        });
    };

    // Handle description update
    const handleDescriptionUpdate = (description?: string) => {
        onQuestionUpdate({
            ...question,
            description: description || ''
        });
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                p: 2,
                alignItems: 'center',
            }}
        >
            {/* Title */}
            <EditableTypography
                value={question.title}
                onChange={handleTitleUpdate}
                multiline
                variant="h6"
                sx={{
                    mb: 2,
                    width: '100%',
                    fontWeight: 'medium',
                    textAlign: 'center',
                    '& input': {
                        textAlign: 'center',
                    },
                    padding: '8px',
                    borderRadius: 1,
                }}
                placeholder={t('Yes/No Question here')}
            />

            {/* Description */}
            <Box sx={{mb: 3, width: '100%'}}>
                <MdEditor
                    value={question.description || ''}
                    onChange={handleDescriptionUpdate}
                    placeholder={t('Question description (optional)')}
                    className={'mini-mdx'}
                />
            </Box>

            {/* Yes/No Buttons */}
            <Stack
                direction="row"
                spacing={2}
                sx={{
                    width: '100%',
                    justifyContent: 'center'
                }}
            >
                <Button
                    variant="outlined"
                    sx={{
                        textTransform: 'none',
                        fontSize: '1.1rem',
                        px: 5,
                        py: 1.5,
                        borderRadius: 2,
                        minWidth: 120,
                    }}
                >
                    {t('Yes')}
                </Button>

                <Button
                    variant="outlined"
                    sx={{
                        textTransform: 'none',
                        fontSize: '1.1rem',
                        px: 5,
                        py: 1.5,
                        borderRadius: 2,
                        minWidth: 120,
                    }}
                >
                    {t('No')}
                </Button>
            </Stack>
        </Box>
    );
};

export default YesNoEditor;
